import apiClient from "./client";

export const fetchAvailableQRCodes = async () => {
  const response = await apiClient.get("/api/qr-codes");
  return response.data.data ?? [];
};
